export default __webpack_public_path__ + "static/media/hand 5 edited 3.b2ad5256.svg";